export default __webpack_public_path__ + "static/media/premium_card_2@2x.52fc960c.png";